<script>
	import { data, mounted } from 'vue2-dropzone';
	import { itemService } from "../../services";
	import { error_message, success_message } from '../../Helper/helper';

	export default 
	{
		name: 'Nutritions',
		component : {
			itemService
		},
		props: {
			'showModal':{
				type:Boolean
			},
			'item_id':{
				type:[String, Number]
			},
			'nutritions':{
				type: [Array, Object]
			},
			'restaurant_id':{
				type:[String, Number]
			},
			'item_name':{
				type:[String]
			}
		},
		data() {
			return {}
		},
		methods: {
			updateNutritions()
			{
				// Removed units from nutrition array because its use for dynamic units value per nutritions
				this.nutritions = JSON.parse(JSON.stringify(this.nutritions, (key, value) =>
					key === "units" ? undefined : value
				));
				itemService.updateNutritions({item_id:this.item_id, restaurant_id: this.restaurant_id, nutritions:this.nutritions}).then(response => 
				{
					if(response.data.code == 200)
					{
						this.$emit('close-modal'); 
						return success_message(response.data.message);
					}
					else
					{
						return error_message(response.data.message);
					}
				}
				).catch(error => 
				{
					return error_message(response.data.message);
				});
			},
			closeModal() {
				this.$emit('close-modal'); // Emit event to close the modal
			}
		}
	}
	
</script>

<template>
	<b-modal v-model="showModal" scrollable :title="trans.get('__JSON__.Update Nutrition')" title-class="font-18" centered size="lg" @close="closeModal"  @hidden="closeModal">
		<b-form @submit.prevent="updateNutritions">
			<div class="row">
				<input type="hidden" name="item_nutrition_id" v-model="nutritions.item_nutrition_id" class="form-control" />
				<div class="col-md-12" v-for="(nutrition, index) in nutritions.nutritions">
					<div class="row">
						<div class="col-md-3">
							<div class="form-group">
								<label for="nutrition">{{ index || '' }}</label>
							</div>
						</div>
						
						<template v-if="Array.isArray(nutrition)">
							<template  v-for="(nutritionMulti, multiIndex) in nutrition">
								<div class="col-md-3" v-if="multiIndex > 0"></div>
								<div class="col-md-3">
									<div class="form-group">
										<input type="text" class="form-control" v-model="nutritionMulti.name" id="search" :placeholder="trans.get('__JSON__.Name')"/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<input type="text" class="form-control" v-model="nutritionMulti.amount" id="search" :placeholder="trans.get('__JSON__.Quantity')"/>
									</div>
								</div>
								<div class="col-md-3">
									<div class="form-group">
										<select
											class="custom-select"
											v-model="nutritionMulti.unit"
											id="unit"
											name="unit"
										>
											<option value="" selected>{{ trans.get('__JSON__.Select Unit') }}</option>
											<option v-for="(unitVal, uniKey) in nutritionMulti.units">{{ unitVal }}</option>
										</select>
									</div>
								</div>
							</template>
						</template>
						<template v-else>
							<div class="col-md-3">
								<div class="form-group">
									<input type="text" class="form-control" v-model="nutrition.amount" id="search" :placeholder="trans.get('__JSON__.Quantity')"/>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<select
										class="custom-select"
										v-model="nutrition.unit"
										id="unit"
										name="unit"
									>
										<option value="" selected>{{ trans.get('__JSON__.Select Unit') }}</option>
										<option v-for="(unitVal, uniKey) in nutrition.units">{{ unitVal }}</option>
									</select>
								</div>
								
							</div>
						</template>
					</div>
				</div>
			</div>
		</b-form>
		<template slot="modal-footer">
			<div class="w-100">
				<b-button variant="primary"  @click="updateNutritions" class="float-right">{{ trans.get('__JSON__.Update') }}</b-button>
				<b-button class="float-left" @click="closeModal">{{ trans.get('__JSON__.Close') }}</b-button>
			</div>
		</template>
	</b-modal>
</template>